exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-custom[data-v-26cd3094] {\n  height: 42px !important;\n  border: 1px solid #cdcdcd !important;\n}\n", ""]);

// exports
